<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Marka</label>
            <v-validator :errors="errors" parameter="VehicleBrandId" :watch="brand">
                <v-select-list v-model="brand" label="Name" placeholder="Marka" :options="brands" img="Logo" />
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Model</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Model" v-model="value.Name">
            </v-validator>
        </div>
    </div>
</template>

<script>
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
export default {
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getBrands();
    },
    data(){
        return{
            brands:[],
        }
    },
    methods:{
        getBrands(){
            VehicleDefinitionsApi.Brand.List()
            .then(res=>{
                this.brands = res.data.Data
            })
        },
    },
    computed:{
        brand:{
            get:function(){
                return this.brands.find(b=>b.Id==this.value.VehicleBrandId)
            },
            set:function(value){
                this.value.VehicleBrandId = value?.Id || null
            }
        }
    }
}
</script>
